import { useState, Fragment } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";
import { contactCustomer } from "actions/messageActions";
import Loading from "components/Loading";

const ModalChat = ({ isOpen, data, onClose, contactCustomer }) => {
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();
    // console.log(data)
    const handleSubmit = async () => {
        setIsLoading(true)
        await contactCustomer({ orderId: data.apiOrderId, message })
        // await onSubmit?.();        
        setIsLoading(false)
        onClose?.();
    };

    return (
        <Fragment>
            <Modal centered={true} size="lg" toggle={onClose} isOpen={!!isOpen}>
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Contact Customer")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onClose();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <Loading isLoading={isLoading} />
                    <div className="form-group mb-5">
                        <label>Name: <strong>{data?.recipient_address?.name}</strong></label>
                    </div>
                    <div className="form-group">
                        <label>Message:</label>
                        <div>
                            <textarea className="form-control" value={message} placeholder={t("Please enter message")} name="message" onChange={(e) => setMessage(e.target.value)} />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                        onClick={handleSubmit}
                    >
                        {t("Send")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { contactCustomer })(ModalChat);
